import { render } from "./TokenSetup.vue?vue&type=template&id=c29c06a6&scoped=true"
import script from "./TokenSetup.vue?vue&type=script&lang=js"
export * from "./TokenSetup.vue?vue&type=script&lang=js"

import "@/Common/Styles/tokenSetup.scss?vue&type=style&index=0&id=c29c06a6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29c06a6"]])

export default __exports__